import { useRecoilValue } from "recoil";
import {
  MergedSuggestedUsersMatchHistorySelector,
  MergedSuggestedUsersSelector,
} from "MVVM/State/mergeSuggestedUsers";
import { UserSuggestionsForSearchSelector } from "MVVM/State/mergeUserSuggestionsForSearch";
import { useUserSuggestionsForSearch as useUserSuggestionsForSearchHook } from "MVVM/Hooks/useUserSuggestionsForSearch";

export const useSuggestedUsers = () => {
  const suggestedUsers = useRecoilValue(MergedSuggestedUsersSelector);
  return {
    suggestedUsers,
    error: null,
    loading: false,
  };
};

export const useSuggestedMatchHistoryUsers = () => {
  const suggestedUsers = useRecoilValue(
    MergedSuggestedUsersMatchHistorySelector,
  );
  return {
    suggestedUsers,
    error: null,
    loading: false,
  };
};

export const useUserSuggestionsForSearch = () => {
  useUserSuggestionsForSearchHook();
  const suggestedUsers = useRecoilValue(UserSuggestionsForSearchSelector);
  return {
    suggestedUsers,
    error: null,
    loading: false,
  };
};
